export enum EVENT_TYPE {
  IDENTITY = 'IDENTITY',
  RAISE = 'RAISE',
  DISTRIBUTE = 'DISTRIBUTE',
  SALE = 'SALE',
}
